import { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import Input from "../../Shared/Input";
import FormFooter from "../../Shared/FormFooter";
import TabFormWrapper from "../../Shared/TabFormWrapper";
import AlertRed from "../../Shared/AlertRed";
import { logoutAllSessions } from "../../../api/authApi";
import { useAuth } from "../../../contexts/AuthContext";

const LogoutSessionsForm = () => {
  const [error, setError] = useState(null);
  const { logout } = useAuth();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      password: "",
    },
  });

  // Logout all sessions mutation
  const { mutate: logoutSessions, isPending: isLoggingOut } = useMutation({
    mutationFn: logoutAllSessions,
    onSuccess: () => {
      // Use centralized logout from AuthContext
      logout();
    },
    onError: (err) => {
      setError({
        title: "Error",
        message:
          err.response?.data?.error?.message ||
          "Failed to log out of all sessions",
      });
    },
  });

  const onSubmit = async (data) => {
    setError(null);
    logoutSessions(data.password);
  };

  return (
    <TabFormWrapper onSubmit={handleSubmit(onSubmit)}>
      {/* Warning callout */}
      <div className="rounded-md bg-signal-amber-50 border border-signal-amber-100 p-4 mb-6">
        <div className="flex">
          <svg
            className="h-5 w-5 text-signal-amber-500 shrink-0"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.168-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.457-1.515-2.625L8.485 2.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z"
              clipRule="evenodd"
            />
          </svg>
          <p className="ml-3 text-sm text-signal-amber-600">
            This will end all your active sessions, including this one. You'll
            need to sign in again.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
        <div className="col-span-full">
          <Input
            id="password"
            name="password"
            label="Your password"
            type="password"
            errormessage={errors?.password?.message}
            {...register("password", {
              required: "Password is required to confirm this action",
            })}
          />
        </div>
      </div>
      <FormFooter
        primaryCaption="Log out all sessions"
        isLoading={isLoggingOut}
        requiresVerification={false}
      />
      {error ? (
        <div className="mt-4">
          <AlertRed title={error.title} message={error.message} />
        </div>
      ) : null}
    </TabFormWrapper>
  );
};

export default LogoutSessionsForm;
